define([
    "./nlgDualListModule",
    "./nlgDualListDirective"
], function(){});